import type { CollaborationOptions } from "@blocknote/core/yjs"
import { contrastRatio, defaultThemePreference } from "~/lib/theme"

export const collaborationColorTokens = [
	"--color-orbit",
	"--chart-1",
	"--chart-2",
	"--chart-3",
	"--chart-4"
]

export function resolveCollaborationColor(
	colorToken: unknown,
	fallback = defaultThemePreference.accent
) {
	const token =
		typeof colorToken === "string" &&
		collaborationColorTokens.includes(colorToken)
			? getComputedStyle(document.documentElement)
					.getPropertyValue(colorToken)
					.trim()
			: fallback
	const color = /^#[0-9a-f]{6}$/i.test(token)
		? token
		: defaultThemePreference.accent
	return {
		color,
		foreground:
			contrastRatio(color, "#ffffff") >= contrastRatio(color, "#000000")
				? "#ffffff"
				: "#000000"
	}
}

export function renderCollaborationCursor(user: CollaborationOptions["user"]) {
	const cursor = document.createElement("span")
	cursor.className = "bn-collaboration-cursor__base orbit-collaboration-cursor"
	cursor.contentEditable = "false"
	cursor.setAttribute("aria-hidden", "true")
	const { color, foreground } = resolveCollaborationColor(
		user.colorToken,
		user.color
	)
	cursor.dataset.colorToken =
		typeof user.colorToken === "string" &&
		collaborationColorTokens.includes(user.colorToken)
			? user.colorToken
			: ""
	cursor.dataset.color = color
	cursor.style.setProperty("--collaborator-color", color)
	cursor.style.setProperty("--collaborator-foreground", foreground)

	const caret = document.createElement("span")
	caret.className = "bn-collaboration-cursor__caret"
	const label = document.createElement("span")
	label.className = "bn-collaboration-cursor__label"
	const name = document.createElement("span")
	name.className = "orbit-collaboration-cursor__name"
	name.textContent = user.name
	label.append(name)
	caret.append(label)
	cursor.append("\u2060", caret, "\u2060")
	return cursor
}
